import { StructuredData as StructuredDataType } from '@/types/structuredData';

interface StructuredDataProps {
  data: StructuredDataType | StructuredDataType[];
}

export const StructuredData = ({ data }: StructuredDataProps) => {
  const jsonLd = Array.isArray(data) ? data : [data];

  return (
    <>
      {jsonLd.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema, null, 0).replace(/</g, '\\u003c'),
          }}
        />
      ))}
    </>
  );
};
